import { render, staticRenderFns } from "./MainTopNav.vue?vue&type=template&id=2147ff10"
import script from "./MainTopNav.vue?vue&type=script&lang=js"
export * from "./MainTopNav.vue?vue&type=script&lang=js"
import style0 from "./MainTopNav.vue?vue&type=style&index=0&id=2147ff10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports